import PropTypes from 'prop-types'
import React from 'react'

import {
    helpers,
    EmptyList,
    ScrollArea,
    Table,
    TableBody,
    Tooltip,
} from 'react-wot-bootstrap'

import { LOADING_DATA } from 'state/actions/CMT/translations'

import {
    roleNames,
    hasAnyPermission,
 } from 'utils/clan_management/roles'

import {
    BLOCK_TYPES,
    NEED_PERMISSIONS_FOR_MEMBER_CONTROL_BLOCK,
} from 'utils/clan_management/constants'

import MembersTableHead from './MembersTableHead'
import ClanModesMembersTableItem from './ClanModesMembersTableItem'
import StatisticsMembersTableItem from './StatisticsMembersTableItem'

import StatisticsHeaders from './StatisticsHeaders.settings'
import ClanModesHeaders from './ClanModesHeaders.settings'

import {
    RoleTooltipContent,
    NameTooltipContent,
    BattlesInClanTooltipContent,
    NotLoggedInEverTooltip,
    NotPlayedInClanModesTooltip,
    Attack6ColumnTooltipContent,
    Attack8ColumnTooltipContent,
    Attack10ColumnTooltipContent,
    FortBattlesColumnTooltipContent,
    ResourceColumnTooltipContent,
    PlayerColumnTooltipContent,
    PlayerStatusColumnTooltipContent,
    RoleColumnTooltipContent,
    Attack11ColumnTooltipContent,
} from '../ClanManagement/tooltips'

import {
    EarnedResourceTooltipContent,
    NotEarnedResourceTooltip,
} from '../ClanManagement/EarnedResourceTooltip'

import {
    BattlesCountColumnTooltipContent,
    DamageColumnTooltipContent,
    DaysInClanColumnTooltipContent,
    ExperienceColumnTooltipContent,
    PersonalRatingColumnTooltipContent,
    WinRateColumnTooltipContent,
} from '../Statistics/tooltips'

import { LOADING_ERROR } from 'helpers/i18n.jsx'


class MembersTable extends React.Component {
    static propTypes = {
        currentMemberId: PropTypes.number.isRequired,
        members: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                role: PropTypes.oneOf(roleNames).isRequired,
            }).isRequired,
        ).isRequired,
        headersSorting: PropTypes.object.isRequired,
        isError: PropTypes.bool.isRequired,
        isProcessing: PropTypes.bool.isRequired,
        statisticsType: PropTypes.oneOf(Object.values(BLOCK_TYPES)).isRequired,
        statistics: PropTypes.object.isRequired,
        selectedMembersIds: PropTypes.arrayOf(PropTypes.number).isRequired,
        heightAfterTable: PropTypes.number.isRequired,
        selectedPeriod: PropTypes.oneOf([1, 7, 28]),
        showClanQuestsCard: PropTypes.bool.isRequired,

        currentMemberRole: PropTypes.string,

        onHeaderClick: PropTypes.func.isRequired,
        onToggleMemberTick: PropTypes.func.isRequired,
        onReloadClick: PropTypes.func.isRequired,
        onTickAllMembers: PropTypes.func.isRequired,
        onMemberContextMenuItemSelected: PropTypes.func.isRequired,
    }

    static SCROLL_AREA_STEP_HEIGHT = 20

    static columnsTooltipContentByTip = {
        [PlayerColumnTooltipContent.tip]: (<PlayerColumnTooltipContent />),
        [PlayerStatusColumnTooltipContent.tip]: (<PlayerStatusColumnTooltipContent />),
        [RoleColumnTooltipContent.tip]: (<RoleColumnTooltipContent />),
        [Attack6ColumnTooltipContent.tip]: (<Attack6ColumnTooltipContent />),
        [Attack8ColumnTooltipContent.tip]: (<Attack8ColumnTooltipContent />),
        [Attack10ColumnTooltipContent.tip]: (<Attack10ColumnTooltipContent />),
        [Attack11ColumnTooltipContent.tip]: (<Attack11ColumnTooltipContent />),
        [FortBattlesColumnTooltipContent.tip]: (<FortBattlesColumnTooltipContent />),
        [ResourceColumnTooltipContent.tip]: (<ResourceColumnTooltipContent />),
        [BattlesCountColumnTooltipContent.tip]: (<BattlesCountColumnTooltipContent />),
        [DamageColumnTooltipContent.tip]: (<DamageColumnTooltipContent />),
        [DaysInClanColumnTooltipContent.tip]: (<DaysInClanColumnTooltipContent />),
        [ExperienceColumnTooltipContent.tip]: (<ExperienceColumnTooltipContent />),
        [PersonalRatingColumnTooltipContent.tip]: (<PersonalRatingColumnTooltipContent />),
        [WinRateColumnTooltipContent.tip]: (<WinRateColumnTooltipContent />),
    }

    constructor(props) {
        super(props)

        this.state = {
            isCMDisplayedOnMember: null,
            scrollAreaHeight: 0,
        }

        this.onResize = this.onResize.bind(this)
        this.onTickAllMembers = this.onTickAllMembers.bind(this)
        this.getMembersTableColumnTooltipContent = this.getMembersTableColumnTooltipContent.bind(this)
        this.getNameTooltipContent = this.getNameTooltipContent.bind(this)
        this.getBattlesInClanTooltipContent = this.getBattlesInClanTooltipContent.bind(this)
        this.getRoleTooltipContent = this.getRoleTooltipContent.bind(this)
        this.getResourceEarnedTooltipContent = this.getResourceEarnedTooltipContent.bind(this)
        this.onContextMenuStateChanged = this.onContextMenuStateChanged.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.members.length !== this.props.members.length ||
            nextProps.heightAfterTable !== this.props.heightAfterTable ||
            nextProps.currentMemberRole !== this.props.currentMemberRole) {
            this.setScrollAreaHeight(nextProps.heightAfterTable)
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize)
        this.setScrollAreaHeight(this.props.heightAfterTable)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize)
    }

    onResize() {
        this.setScrollAreaHeight(this.props.heightAfterTable)
    }

    onTickAllMembers() {
        const { members, selectedMembersIds } = this.props
        if (members.length === selectedMembersIds.length) {
            this.props.onTickAllMembers([])
        } else {
            this.props.onTickAllMembers(members.map((member) => member.id))
        }
    }

    onContextMenuStateChanged(memberId, isCMDisplayed) {
        this.setState({
            isCMDisplayedOnMember: isCMDisplayed ? memberId : null,
        })
    }

    setScrollAreaHeight(heightAfterTable) {
        const coords = this._table.getBoundingClientRect()
        const scrollAreaHeight = window.innerHeight - coords.top - this._tableHead.offsetHeight - heightAfterTable
        if (this.state.scrollAreaHeight !== scrollAreaHeight) {
            this.setState({ scrollAreaHeight })
        }
    }

    isDisplayCheckboxes() {
        const { currentMemberRole } = this.props
        return currentMemberRole && hasAnyPermission(currentMemberRole, NEED_PERMISSIONS_FOR_MEMBER_CONTROL_BLOCK)
    }

    renderTableItemInstance(props) {
        const statistics = this.props.statistics[props.memberId]

        return this.props.statisticsType === BLOCK_TYPES.CLAN_MODES ?
            (<ClanModesMembersTableItem {...props} {...statistics} />) :
            (<StatisticsMembersTableItem {...props} {...statistics} />)
    }

    renderMembers(shouldShowLegendaryColumn) {
        const displayCheckbox = this.isDisplayCheckboxes()
        const selectedMembersIdsSet = new Set(this.props.selectedMembersIds)
        return this.props.members.map((member) => {
            const isActive = selectedMembersIdsSet.has(member.id)
            const itemProps = {
                key: `${this.props.statisticsType}${member.id}`,
                memberId: member.id,
                memberDaysInClan: member.daysInClan,
                memberRole: member.role,
                memberName: member.name,
                memberStatus: member.status,
                memberLogoutAt: member.logoutAt,

                shouldShowLegendaryColumn,
                displayCheckbox,
                isActive,
                isOwn: member.id === this.props.currentMemberId,
                isFriend: member.isFriend,
                isChecked: isActive,
                isCMDisplayed: this.state.isCMDisplayedOnMember === member.id,
                onTickMember: displayCheckbox ? this.props.onToggleMemberTick : null,
                onContextMenuItemSelected: this.props.onMemberContextMenuItemSelected,
                onContextMenuStateChanged: this.onContextMenuStateChanged,
            }

            return this.renderTableItemInstance(itemProps)
        })
    }

    getMembersTableColumnTooltipContent(tooltipTip) {
        return tooltipTip && MembersTable.columnsTooltipContentByTip[tooltipTip]
    }

    getNameTooltipContent(tooltipTip) {
        if (!tooltipTip) return null

        const memberId = Number(tooltipTip)
        const member = this.props.members.find((member) => member.id === memberId)
        return (<NameTooltipContent name={member.name} />)
    }

    getBattlesInClanTooltipContent(tooltipTip) {
        if (!tooltipTip) return null

        const tips = tooltipTip.split('-')
        const field = tips[0]
        const memberId = tips[1]

        const statistics = this.props.statistics[memberId]

        const fieldValue = helpers.thousands(statistics[field])
        const fieldWinsPercent = helpers.percent(statistics[`${field}WinsPercent`])
        return (
            <BattlesInClanTooltipContent
                battles={fieldValue}
                winrate={fieldWinsPercent}
            />
        )
    }

    getRoleTooltipContent(tooltipTip) {
        return tooltipTip ? (<RoleTooltipContent role={tooltipTip} />) : null
    }

    getResourceEarnedTooltipContent(memberId) {
        if (!memberId) return null

        const statistics = this.props.statistics[memberId]

        return (
            <EarnedResourceTooltipContent
                selectedPeriod={this.props.selectedPeriod}
                statistics={statistics}
                showClanQuestsCard={this.props.showClanQuestsCard}
            />
        )
    }

    render() {
        const isClanModes = this.props.statisticsType === BLOCK_TYPES.CLAN_MODES
        const showLegendaryColumn = isClanModes ?
            Object.values(this.props.statistics).some(function(item) {
                return item.sortiesLegendary
            }) : false
        const headers =
            isClanModes ? ClanModesHeaders(showLegendaryColumn) : StatisticsHeaders


        const tableContent = this.props.isError ? (
            <EmptyList
                title={LOADING_ERROR.title}
                message={LOADING_ERROR.message}
                buttonCaption={LOADING_ERROR.refresh_button_caption}
                height={this.state.scrollAreaHeight}
                onButtonClick={this.props.onReloadClick}
            />
        ) : (
            <div style={{ height: this.state.scrollAreaHeight }}>
                <ScrollArea
                    modifier="table"
                    stepHeight={MembersTable.SCROLL_AREA_STEP_HEIGHT}
                    scrollableAreaHeight={this.state.scrollAreaHeight}
                >
                    <TableBody>
                        {this.renderMembers(showLegendaryColumn)}
                    </TableBody>
                </ScrollArea>
            </div>
        )

        const isDisplayCheckbox = this.isDisplayCheckboxes()
        const isAllMembersSelected = (
            isDisplayCheckbox &&
            this.props.members.length > 0 &&
            this.props.selectedMembersIds.length === this.props.members.length
        )

        const nameTooltip = this.state.isCMDisplayedOnMember ? null : (
            <Tooltip
                id="member-name-tooltip"
                getContent={this.getNameTooltipContent}
            />
        )

        return (
            <div ref={(c) => this._table = c}>
                <Table
                    isScrollable
                    processingCaption={LOADING_DATA}
                    isProcessing={this.props.isProcessing}
                >
                    <div ref={(c) => this._tableHead = c}>
                        <MembersTableHead
                            headers={headers}
                            headersSorting={this.props.headersSorting}
                            isChecked={isAllMembersSelected}
                            displayCheckbox={isDisplayCheckbox}
                            onHeaderClick={this.props.onHeaderClick}
                            onTickAllMembers={isDisplayCheckbox ? this.onTickAllMembers : null}
                        />
                    </div>
                    {tableContent}
                </Table>

                <NotPlayedInClanModesTooltip />
                <NotEarnedResourceTooltip />
                <NotLoggedInEverTooltip />

                {nameTooltip}
                <Tooltip
                    id="members-table-column-tooltip"
                    getContent={this.getMembersTableColumnTooltipContent}
                />
                <Tooltip
                    id="battles-in-clan-tooltip"
                    getContent={this.getBattlesInClanTooltipContent}
                />
                <Tooltip
                    id="member-role-tooltip"
                    getContent={this.getRoleTooltipContent}
                />
                <Tooltip
                    id="resource-earned-tooltip"
                    isWide
                    getContent={this.getResourceEarnedTooltipContent}
                />
            </div>
        )
    }
}

export default MembersTable



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/MembersTable/MembersTable.js